const gridProfile = {
  gridProfile: {
    pageHeader: 'Grid Profile',
    name: 'Name',
    description: 'Description',
    createdBy: 'Created By',
    noGrid: '** No Grids Available **',
    grids: 'Grids'
  }
};

export default gridProfile;
